import request from '@/utils/request'
/**
 * 字典列表
 * @param {*} data 
 * @returns 
 */
export const getDictList = (data) =>  request({
    method: 'post',
    url: `/yzdservice/api/type/all`,
    data: data
})

/**
 * 新增字典
 * @param {*} data 
 * @returns 
 */
 export const addDict = (data) =>  request({
    method: 'post',
    url: `/yzdservice/api/type/add`,
    data: data
})

/**
 * 删除字典
 * @param {*} data 
 * @returns 
 */
 export const deleteDict = (id) =>  request({
    method: 'delete',
    url: `/yzdservice/api/type/${id}`
})

/**
 * 修改字典
 * @param {*} data 
 * @returns 
 */
 export const updateDict = (data) =>  request({
    method: 'put',
    url: `/yzdservice/api/type/edit`,
    data: data
})

/**
 * 刷新字典
 * @param {*} data 
 * @returns 
 */
 export const refreshDict = (data) =>  request({
    method: 'put',
    url: `/yzdservice/api/type/refresh`,
    data: data
})

//////////////////////////////////////
/**
 * 字典数据列表
 * @param {*} data 
 * @returns 
 */
 export const getDictDataList = (data) =>  request({
    method: 'post',
    url: `/yzdservice/api/data/all`,
    data: data
})

/**
 * 新增字典数据
 * @param {*} data 
 * @returns 
 */
 export const addDictData = (data) =>  request({
    method: 'post',
    url: `/yzdservice/api/data/add`,
    data: data
})

/**
 * 删除字典数据
 * @param {*} data 
 * @returns 
 */
 export const deleteDictData = (id) =>  request({
    method: 'delete',
    url: `/yzdservice/api/data/${id}`
})

/**
 * 修改字典数据
 * @param {*} data 
 * @returns 
 */
 export const updateDictData = (data) =>  request({
    method: 'put',
    url: `/yzdservice/api/data/edit`,
    data: data
})

/**
 * 刷新字典数据
 * @param {*} dictType 
 * @returns 
 */
 export const refreshDictData = (dictType) =>  request({
    method: 'put',
    url: `/yzdservice/api/data/refresh/${dictType}`
})




